export default __webpack_public_path__ + "static/employee-payslip-generator-28e034ac18e4316edb720bc300aa5b4a.png";